var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPanWithBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5Z",
    fill: "#E2F2EE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_2100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6446 10.2824C25.3854 9.97607 25.0225 9.78896 24.6227 9.75556L10.5385 8.57955C10.1385 8.54615 9.74971 8.67049 9.44335 8.92959C9.13823 9.18767 8.95139 9.54873 8.91694 9.94665L8.63358 12.6051H7.50214C6.67386 12.6051 6 13.2789 6 14.1072V22.9237C6 23.752 6.67386 24.4258 7.50214 24.4258H21.6354C22.4637 24.4258 23.1376 23.752 23.1376 22.9237V21.4935L23.6391 21.5354C23.6814 21.5389 23.7235 21.5406 23.7652 21.5406C24.5374 21.5406 25.1957 20.9465 25.2611 20.1634L25.9947 11.3775C26.028 10.9777 25.9037 10.5888 25.6446 10.2824ZM7.50214 13.3863H21.6354C22.0329 13.3863 22.3563 13.7097 22.3563 14.1072V14.9106H6.78125V14.1072C6.78125 13.7097 7.10464 13.3863 7.50214 13.3863ZM6.78125 15.6918H22.3563V17.3125H6.78125V15.6918ZM21.6354 23.6446H7.50214C7.10464 23.6446 6.78125 23.3212 6.78125 22.9237V18.0937H22.3563V22.9237C22.3563 23.3212 22.0329 23.6446 21.6354 23.6446ZM25.2161 11.3125L24.4825 20.0984C24.4494 20.4945 24.1002 20.79 23.7041 20.7568L23.1376 20.7095V14.1072C23.1376 13.2789 22.4637 12.6051 21.6354 12.6051H9.41928L9.69424 10.0254C9.69456 10.0224 9.69483 10.0195 9.69506 10.0165C9.72815 9.62037 10.0772 9.3249 10.4735 9.3581L24.5577 10.5341C24.7496 10.5501 24.9238 10.6399 25.0481 10.787C25.1725 10.934 25.2321 11.1206 25.2161 11.3125Z",
    fill: "#00A657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7216 19.2551H16.9622C16.7464 19.2551 16.5715 19.43 16.5715 19.6458V22.0984C16.5715 22.3142 16.7464 22.4891 16.9622 22.4891H20.7216C20.9374 22.4891 21.1122 22.3142 21.1122 22.0984V19.6458C21.1122 19.43 20.9374 19.2551 20.7216 19.2551ZM20.331 21.7078H17.3528V20.0364H20.331V21.7078Z",
    fill: "#00A657"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_2100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(6 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanWithBg);
export default __webpack_public_path__ + "static/media/pan-with-bg.08aa8c92551d4d81465c0c27295ed9e8.svg";
export { ForwardRef as ReactComponent };